"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("./styled");
const main_1 = require("./../button/main");
const main_2 = require("./../icon/main");
function Pagination(args) {
    const { totalCount, pageSize = 50, currentPage = 1, showCount = 2, variant, onChange, } = args;
    const totalPages = Math.ceil(totalCount / pageSize);
    let minPage = Math.max(currentPage - showCount, 1);
    let maxPage = Math.min(minPage + showCount * 2, totalPages);
    minPage = Math.max(maxPage - showCount * 2, 1);
    const pages = [];
    while (minPage <= maxPage) {
        pages.push(minPage);
        minPage++;
    }
    return !totalCount ? (react_1.default.createElement(styled_1.StyledNoData, null, "No Data Available")) : (react_1.default.createElement(styled_1.StyledPagination, { "data-testid": "pagination" },
        react_1.default.createElement(main_1.Button, { outlined: true, noBorder: true, variant: variant, disabled: currentPage <= 1, onClick: () => onChange && onChange(currentPage - 1) },
            react_1.default.createElement(main_2.Icon, { name: "chevron", rotate: "left" })),
        pages[0] !== 1 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(main_1.Button, { outlined: currentPage !== 1, noBorder: currentPage !== 1, variant: variant, onClick: () => onChange && onChange(1) }, "1"),
            "\u2026")),
        pages.map((num) => {
            return (react_1.default.createElement(main_1.Button, { key: num, outlined: currentPage !== num, noBorder: currentPage !== num, variant: variant, onClick: () => onChange && onChange(num) }, num));
        }),
        pages[pages.length - 1] !== totalPages && (react_1.default.createElement(react_1.default.Fragment, null,
            "\u2026",
            react_1.default.createElement(main_1.Button, { outlined: currentPage !== totalPages, noBorder: currentPage !== totalPages, variant: variant, onClick: () => onChange && onChange(totalPages) }, totalPages))),
        react_1.default.createElement(main_1.Button, { outlined: true, noBorder: true, variant: variant, disabled: currentPage >= totalPages, onClick: () => onChange && onChange(currentPage + 1) },
            react_1.default.createElement(main_2.Icon, { name: "chevron", rotate: "right" }))));
}
exports.Pagination = Pagination;
//# sourceMappingURL=pagination.js.map